export default {
  computed: {
    orderTypeSingle() {
      if (this.loading) {
        return '';
      }
      console.log(this.order);
      if (this.order.details.rows) {
        const rows = this.order.details.rows;

        if (rows.accomodation && rows.accomodation.length) {
          return 'accomodation';
        }
        if (rows.rental && rows.rental.length) {
          return 'rental';
        }
        if (rows.skipass && rows.skipass.length) {
          return 'skipass';
        }
        if (rows.skischool && rows.skischool.length) {
          return 'skischool';
        }
        if (rows.addon && rows.addon.length) {
          return 'addon';
        }
      }

      return 'other';
    },
    orderTypes() {
      const types = [];

      if (this.loading) {
        return types;
      }

      if (this.order.details.rows) {
        const rows = this.order.details.rows;

        if (rows.accomodation && rows.accomodation.length) {
          types.push('accomodation');
        }
        if (rows.rental && rows.rental.length) {
          types.push('rental');
        }
        if (rows.skipass && rows.skipass.length) {
          types.push('skipass');
        }
        if (rows.skischool && rows.skischool.length) {
          types.push('skischool');
        }
        if (rows.addon && rows.addon.length) {
          types.push('addon');
        }
        if (rows.other && rows.other.length) {
          types.push('other');
        }
      } else {
        types.push('other');
      }

      return types;
    },
    orderTypeVisual() {
      if (this.loading) {
        return '';
      }

      const map = {
        accomodation: 'Boende',
        rental: 'Skidhyra',
        skipass: 'Liftkort',
        skischool: 'Skidskola',
        addon: 'Tillval',
        skischule: 'Skidskola',
        other: 'Bokning',
      };

      const oTypes = this.orderTypes;

      return oTypes.map(type => map[type]).join(' + ');
    },
  },
  methods: {
    extradetails(type) {
      if (this.loading) {
        return [];
      }

      let list = (this.order.details.rows[type] || []).slice();

      list = list.map((row) => {
        let skiername = (row.skiername || '').toLowerCase().trim();
        let details = this.skierAttributes(row);
        const arrival = row.arrival;
        const departure = row.departure;

        if (type === 'skischool') {
          skiername = (row.people_as_string || '').toLowerCase().trim();
          details = '-';
        }

        const sorter = `${skiername}-${details}-${arrival}-${departure}`;
        const group1 = `${skiername}`;
        const group2 = `${details}-${arrival}-${departure}`;

        return {
          ...row,
          sorter,
          group1,
          group2,
        };
      });

      const sorted = list.sort((a, b) => {
        const aSort = a.sorter;
        const bSort = b.sorter;

        if (aSort < bSort) {
          return -1;
        }
        if (aSort > bSort) {
          return 1;
        }
        return 0;
      });

      const grouped = {};

      sorted.forEach((row) => {
        const group1 = row.group1;
        const group2 = row.group2;

        if (typeof grouped[group1] === 'undefined') {
          grouped[group1] = {};
        }

        if (typeof grouped[group1][group2] === 'undefined') {
          grouped[group1][group2] = [];
        }

        grouped[group1][group2].push(row);
      });

      return Object.values(grouped);
    },
    concatenatedList(list) {
      const s = list
        .filter(row => row.value)
        .map((row, index) => `${index > 0 ? row.title.toLowerCase() : row.title} ${row.value} ${row.suffix}`.trim())
        .join(', ');

      if (!s) {
        return '';
      }

      // Make first character uppercase
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    skierAttributes(detail) {
      return this.concatenatedList([{
        title: 'Längd',
        value: detail.skierheight,
        suffix: 'cm',
      }, {
        title: 'Vikt',
        value: detail.skierweight,
        suffix: 'kg',
      }, {
        title: 'Skostorlek',
        value: detail.skiershoe,
        suffix: '',
      }]);
    },
    schoolerAttributes(detail) {
      return this.concatenatedList([{
        title: 'Start:',
        value: detail.start_time,
        suffix: '',
      }, {
        title: 'Plats:',
        value: detail.location,
        suffix: '',
      }]);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/my-order.js